import React from 'react';
import { styled } from 'styled-components';

import editIcon from '../../assets/icons/icon_edit.svg';
import { IconButton } from '../../common/components/Icon';

export const SaveButton = styled.button`
  flex-shrink: 0;
  width: 60px;
  height: 37px;
  margin: 0 0 0 5px;
  border-radius: 4px;
  box-sizing: border-box;
  border: none;
  background-color: ${p => '#2e5be0' || p.theme.colors.textColorInPrimary};
  color: ${p => p.theme.colors.white};

  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    background-color: #e8e8e8;
    color: #bdbdbd;
    cursor: not-allowed;
  }
`;

interface EditButtonProps {
  onClick(): void;
}
export const EditButton = ({ onClick }: EditButtonProps) => {
  return (
    <IconButton
      imageUrl={editIcon}
      width="24px"
      margin="0px 4px 0px 17px"
      height="24px"
      imageWidth="14px"
      color={'var(--HPACS_Text_Light_Grey, #a3a6ab)'}
      onClick={onClick}
    />
  );
};
